import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { checkAccess } from '@/creditflowresearch/application/User/access/checkAccess';
import { detectProductRouteType } from '@/creditflowresearch/domain/Product/selectors/detectProductRouteType';
import { selectProductIdsFromQuery } from '@/creditflowresearch/domain/Product/selectors/selectProductIdsFromQuery';
import { selectRegionIdsFromQuery } from '@/creditflowresearch/domain/Region/selectors/selectRegionIdsFromQuery';
import { IUserPlanPreferences } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';

interface IProductRegionQueryParams {
  pathname: string,
  query: IQueryParams,
  productsList: IProduct[],
  regionsList: IRegion[],
  accessibleProductsIds?: string[],
  accessibleRegionsIds?: string[],
  plan: UserPlanType,
  preferences?: IUserPlanPreferences,
}

interface ISelectedProductsRegions {
  productIds: string[],
  regionIds: string[],
}

export const selectProductAndRegionIdsFromQuery = (
  params: IProductRegionQueryParams,
): ISelectedProductsRegions => {
  const routeType = detectProductRouteType(params.pathname);
  const hasAccess = checkAccess([UserPlan.isSatisfiedPremiumPlan(params.plan)]);

  const productIds = selectProductIdsFromQuery(
    routeType,
    params.query,
    params.productsList,
    params.accessibleProductsIds || [],
    hasAccess,
  );

  const regionIds = selectRegionIdsFromQuery(
    params.query,
    params.regionsList,
    params.accessibleRegionsIds || [],
    params.plan,
    params.preferences?.regionIds,
  );

  return { productIds, regionIds };
};
